Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = renderComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _warning = require('./warning');

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function renderComponent(props, name) {
  var render = props.render,
      children = props.children,
      Component = props.component,
      rest = _objectWithoutProperties(props, ['render', 'children', 'component']);

  if (Component) {
    return _react2['default'].createElement(Component, _extends({}, rest, { render: render }));
  }

  if (render) {
    return render(_extends({}, rest, { children: children })); // inject children back in
  }

  if (typeof children !== 'function') {
    (0, _warning2['default'])(false, 'Must specify either a render prop, a render function as children, or a component prop to ' + String(name));
    return null;
  }

  return children(rest);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/formera/lib/helpers/renderComponent.js
// module id = 71
// module chunks = 0